import { render, staticRenderFns } from "./ManageMaterials.vue?vue&type=template&id=63925eca&"
import script from "./ManageMaterials.vue?vue&type=script&lang=js&"
export * from "./ManageMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports